import { apiTutorObtenerLista } from "../API";
import { _APP_DATA } from "../AppData";
import { IParent, IApiResult } from "../models/Entities";
import { RequestData } from "../utils/RequestData";


export const _TUTORES_MAP: Map<number, IParent> = new Map();
let tutorMaxDate: string | null = null;
export function _SvTutorObtenerLista(callback: (data: Array<IParent>) => void) {
    let params = {
        IdGrupo: _APP_DATA.userData.IdGrupo,
        Modificacion: tutorMaxDate
    };

    new RequestData<IApiResult<IParent[]>>(apiTutorObtenerLista)
        .Params(params)
        .Completion((response, error) => {
            let resultData = response?.Datos || [];

            if (error)
                console.log(error.name, error.message);

            resultData.forEach(item => {
                if (!item.EnUso)
                    _TUTORES_MAP.delete(item.Id);

                else
                    _TUTORES_MAP.set(item.Id, item);
            });

            let maxDate = response?.Maxima || null;
            if (resultData.length > 0 && maxDate != null)
                tutorMaxDate = maxDate;

            if (resultData.length > 0 && callback) callback(resultData);
        }).Get();
}

export function _SvTutorClearLocalData() {
    _TUTORES_MAP.clear()
    tutorMaxDate = null
}